import type { FaireProductEntity } from "../../entity_types/product";

export const p_pgefxn5brb: FaireProductEntity = {
  token: "p_pgefxn5brb",
  type: "product",
  name: "Peanut Butter Chocolate Chunk Protein Bar Carton (12 Bars)",
  brandToken: "b_upjbcsvbjr",
  brandName: "David Protein",
  imageUrl:
    "https://cdn.faire.com/fastly/5891f4d4997d53777391368778ca1ad3cb12a4e865c17d588bb0e3ddd72f5b15.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4702e9b1512f15ad2a858ebdbe3b633c04a9170848f19eae8859a03522d77301.png",
  ],
  priceDollars: 29.83,
  description:
    "Sweet and salty, creamy peanut butter dough. Filled with rich chocolate chunks and roasted peanut crisps. Each bite is packed with flavor and different textures.",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:17.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
